export default "__VITE_ASSET__Dj5OAzzU__"